<template>
  <div>
    <!-- {{ itemsToRemove }} -->
    <vue-multi-select
      ref="multiSelect"
      v-model="values"
      :options="options"
      :btnLabel="btnLabel"
      track-by="Fullname"
      :searchable="true"
      :preserve-search="true"
      :filters="filters"
      @open="open"
      @close="close"
      :selectOptions="data"
      class="text-left"
    >
      <template v-slot:option="{ option }" #selection="{}">
        <input
          class="cursor-pointer bg-primary"
          type="checkbox"
          :checked="option.selected"
        />
        <span class="ml-2 cursor-pointer multiselect__single">{{
          decryptDataLocal(option.Fullname, decryptionKey)
        }}</span>
      </template>
    </vue-multi-select>
    <div class="mt-4">
      <ul class="list-disc pl-5">
        <li
          v-for="value in filteredValues"
          :key="value.Id"
          class="mt-2 flex items-center"
        >
          <div
            class="h-8 w-8 rounded-full flex cursor-pointer"
            @click="goToProfile()"
          >
            <div v-if="loading" class="flex items-center gap-1 h-8 w-8">
              <img
                class="h-full w-full rounded-full"
                src="@/assets/icons/loader.gif"
              />
            </div>

            <img
              v-else-if="!loading && profilePictures[value.Id]"
              :src="profilePictures[value.Id]"
              alt="Profile Picture"
              class="w-8 h-8 rounded-full"
            />

            <div v-else-if="false" class="flex items-center gap-1 h-8 w-8">
              <img class="h-full w-full rounded-full" :src="false" />
            </div>
            <div v-else class="flex items-center gap-1 h-8 w-8 rounded-full">
              <img
                v-if="false && !loading"
                class="h-full w-full rounded-full"
                :src="false"
                alt="avatar"
              />

              <img
                v-else
                class="h-full w-full rounded-full"
                src="@/assets/icons/user.png"
                alt="avatar"
              />
            </div>
          </div>
          <div class="pl-3 flex-1">
            <span class="font-semibold">{{
              decryptDataLocal(value.Fullname, decryptionKey)
            }}</span>
            <span class="text-sm text-gray-600"> ({{ value.EmployeeNo }})</span>
          </div>
          <button
            @click="() => removeValue(value)"
            class="ml-2 text-red-500 hover:text-red-700 transition-colors"
            aria-label="Remove"
            role="button"
            type="button"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </li>
      </ul>
    </div>
    <!-- {{ values }} -->
  </div>
</template>

<script>
import vueMultiSelect from "vue-multi-select";
import "vue-multi-select/dist/lib/vue-multi-select.css";
import decryptData from "./decrypt";
import { viewSecuredAttachment } from "./secureAttachmentsViewer";
import { mapGetters } from "vuex";

export default {
  name: "CustomMultiSelect",
  props: ["employees", "selectionCallback"],
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      actionType: "",
      btnLabel: (values) => `Selected Employees (${values.length})`,
      name: "Employees",
      profilePictures: {},
      loading: false,
      values: [],
      itemsToRemove: [],
      data: [
        {
          name: "Employees",
          list: this.employees,
        },
      ],
      filters: [
        {
          nameAll: "Select all",
          nameNotAll: "Deselect all",
          func() {
            return true;
          },
        },
      ],
      options: {
        multi: true,
        groups: true,
        searchable: true,
      },
    };
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
  },

  computed: {
    ...mapGetters(["getToken"]),
    filteredValues() {
      return this.values.filter(
        (value) => !this.itemsToRemove.includes(value.Id)
      );
    },
    // filtererdSelection(){
    //   return  this.values.filter(
    //     (value) => !this.itemsToRemove.includes(value.Id)
    //   );
    // }
  },

  watch: {
    values: {
      immediate: true,
      handler(newValues) {
        if (this.actionType == "") {
          this.fetchProfilePictures(newValues);
        }
      },
    },
  },

  methods: {
    async fetchProfilePictures(values) {
      const promises = values.map(async (value) => {
        if (!this.profilePictures[value.Id]) {
          try {
            const imageUrl = await viewSecuredAttachment(
              value.ProfilePicture,
              this.getToken
            );
            this.$set(this.profilePictures, value.Id, imageUrl);
          } catch (error) {
            console.error("Error fetching profile picture:", error);
            this.$set(
              this.profilePictures,
              value.Id,
              "@/assets/icons/user.png"
            );
          }
        }
      });
      await Promise.all(promises);
    },
    removeValue({ Id }) {
      this.actionType = "removeEmployee";
      if (!this.itemsToRemove.includes(Id)) {
        this.itemsToRemove.push(Id);
      }
    },

    close() {
      const memberIds = this.values.map(({ MemberId, Id }) => {
        return MemberId ? { MemberId } : { MemberId: Id };
      });
      this.selectionCallback(memberIds);
    },
    open() {},
  },
  components: {
    vueMultiSelect,
  },
};
</script>

<style>
/* Use more specific selectors to target elements inside vue-multi-select */
.vue-multi-select .select .checkboxLayer {
  width: 100% !important;
}

.vue-multi-select .select .show {
  width: 100% !important;
}
.select[data-v-0ea235da] {
  width: 100% !important;
}

.select .checkboxLayer[data-v-0ea235da] {
  width: 100% !important;
}
</style>
